import {openPatientDrawer} from '@/modules/patients/components/patient-drawer/util'
import {openPatientRecordWindow} from '@/modules/patients/components/patient-record-window/util'
import {getPatientFullName} from '@/modules/patients/functions'
import {Patient} from '@cypro/engine/schema'
import {ResourceTag, ResourceTagBehavior, ResourceTagProps} from '@cypro/ui/components/ui/tags/resource-tag'
import {useTranslate} from '@tolgee/react'

export interface PatientTagProps extends Omit<ResourceTagProps, 'behavior'> {
  patient?: Patient
  behavior?: ResourceTagBehavior | 'open-record'
}

export function PatientTag({patient, children, behavior, ...props}: PatientTagProps) {
  const {t} = useTranslate('common')

  return (
    <ResourceTag
      onClick={() => {
        if (!patient) return
        if (behavior === 'open-drawer') return openPatientDrawer(patient)
        if (behavior === 'open-record') return openPatientRecordWindow(patient.id)
      }}
      {...props}
      data-e2e="patient-tag"
      data-patient-id={patient?.id}
    >
      {children}
      {!children && (getPatientFullName(patient) || patient?.id || t('unknown'))}
    </ResourceTag>
  )
}
